import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { Section } from './Section';
const DELIVERABLES = [{
  icon: BookOpenIcon,
  label: 'Libro principal Diccionario Apple',
  detail: '6 módulos: ajustes, batería, trucos, herramientas, cámara y seguridad.'
}, {
  icon: GiftIcon,
  label: 'Bono 1 · Configuración Perfecta',
  detail: 'Dejá tu iPhone listo desde el primer día.'
}, {
  icon: GiftIcon,
  label: 'Bono 2 · Checklist de Seguridad y Privacidad',
  detail: 'Qué revisar para proteger tu información.'
}, {
  icon: GiftIcon,
  label: 'Bono 3 · Trucos Ocultos',
  detail: 'Gestos, atajos y funciones que ahorran tiempo.'
}, {
  icon: GiftIcon,
  label: 'Bono 4 · Organización Digital',
  detail: 'Apps, fotos y notas ordenadas con una rutina simple.'
}, {
  icon: GiftIcon,
  label: 'Bono 5 · Manual de Cámara',
  detail: 'Fotos y videos mucho más profesionales.'
}];
export function ContentPreview() {
  return <Section className="bg-ink-950" innerClassName="max-w-5xl" data-id="element-93" data-mp="1pcgr57vgdbez">
      <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:items-center" data-id="element-94" data-mp="1pax7r8ei2k8z">
        <div className="mx-auto w-full max-w-[16rem]" data-id="element-95" data-mp="1kg00a5wvciy7">
          <div className="overflow-hidden rounded-[2rem] border border-white/10 bg-ink-900 p-2" data-id="element-96" data-mp="1z3bcma0vk6zd">
            <video src="https://cdn.magicpatterns.com/uploads/47doiaAPDiN8K3Pga2ZcYa/scrol apple .mov" className="w-full rounded-[1.5rem]" autoPlay muted loop playsInline controls data-id="element-97" data-mp="1uc32fbrq0hl5" />
          </div>
          <p className="mt-3 text-center text-[11px] uppercase tracking-[0.18em] text-white/35" data-id="element-98" data-mp="2i0w31ljafdm3">
            Vista real del contenido
          </p>
        </div>

        <div data-id="element-99" data-mp="nnwj5g7vjx90">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-gold" data-id="element-100" data-mp="nnecdpnl60mu">
            Mirá un poco del contenido
          </p>
          <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-101" data-mp="iqe73gyk91ws">
            Esto te llevás hoy
          </h2>

          <ul className="mt-8 space-y-2.5" data-id="element-102" data-mp="1cean59w12csa">
            {DELIVERABLES.map(({
            icon: Icon,
            label,
            detail
          }) => <li key={label} className="flex items-start gap-4 rounded-2xl border border-white/8 bg-ink-900 px-5 py-4" data-id="element-103" data-mp="1hddpgmkmi4wk">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-accent/15" data-id="element-104" data-mp="1rbt7m01oa3tx">
                  <Icon className="h-4 w-4 text-accent-soft" aria-hidden="true" data-id="element-105" data-mp="1vd6f0ekeyf2y" />
                </span>
                <div data-id="element-106" data-mp="204wpqln9j4uw">
                  <p className="text-sm font-bold text-white" data-id="element-107" data-mp="25381x3115rga">{label}</p>
                  <p className="mt-1 text-xs leading-relaxed text-white/55" data-id="element-108" data-mp="252g4dmnvhjnd">
                    {detail}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}